import { render, staticRenderFns } from "./create-testcase.vue?vue&type=template&id=7bd94144&"
import script from "./create-testcase.ts?vue&type=script&lang=js&"
export * from "./create-testcase.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports